const ITEMS = ["LOGO DESIGN", "BRANDING", "VIDEO EDITING", "IMAGE EDITING", "SOCIAL CONTENT", "MOTION GRAPHICS", "WEBSITE DESIGN", "GAME ART"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/5 bg-[#0c0c0f] py-6 edge-fade-y" aria-hidden>
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span
              className={`font-display font-black text-3xl sm:text-5xl tracking-tight px-6 ${
                i % 2 === 0 ? "text-white/10" : "text-transparent"
              }`}
              style={i % 2 !== 0 ? { WebkitTextStroke: "1px rgba(229,9,20,0.45)" } : undefined}
            >
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-arsenal/60 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
